import axios from 'axios';
import { Product } from '../../types/Product';
import { PaginatedResult, PaginationParams, TableFilterData } from '../../types/general-types';

class ProductsService {
  async getAll(): Promise<Product[]> {
    const result = await axios.get('/products');
    return result.data.map(mapFromApiResponse);
  }

  async get(id: string): Promise<Product> {
    const result = await axios.get(`/products/${id}`);
    return result.data && mapFromApiResponse(result.data);
  }

  async search(filters: TableFilterData, paginationParams: PaginationParams): Promise<PaginatedResult<Product>> {
    const result = await axios.post(`/products/search`, { filters, paginationParams });
    return {
      data: result.data.data.map(mapFromApiResponse),
      totalCount: result.data.totalCount,
    };
  }

  async delete(id: string): Promise<void> {
    return axios.delete(`/products/${id}`);
  }

  async create(postData: Product): Promise<void> {
    return axios.post(`/products`, mapToRequestBody(postData));
  }

  async edit(postData: Product, id: string): Promise<void> {
    return axios.put(`/products/${id}`, mapToRequestBody(postData));
  }
}

const mapFromApiResponse = (product: any): Product => {
  return {
    ...product,
  };
};

const mapToRequestBody = (product: Product): any => {
  const result = {
    id: product.id,
    name: product.name,
    description: product.description,
    targetQuantity: product.targetQuantity,
    unit: product.unit,
    densityGMl: product.densityGMl,
    tareWeightG: product.tareWeightG,
  };

  return result;
};

const productsService = new ProductsService();
export default productsService;
